module.exports = __webpack_public_path__ + "static/media/crystal_pick.3c0740fb.mp3";